import { Component, OnInit, Input, ViewChild, AfterViewInit } from '@angular/core';
import { ProjectStatus } from '../../data/project/statuses/project-status';
import { Project } from '../../data/project/project';
import { ProjectHolder } from '../../interfaces/project-holder';
import { ProjectService } from '../../data/project/project.service';
import { FinishingVendorService } from '../../../vendor/data/finish-vendor.service';
import { FinishingVendor } from '../../../vendor/data/finish-vendor';
import { KanbanColumn } from '../../../../../../../desktop/src/app/modules/kanban-board/data/kanban-column';
import {ProjectActivityService} from '../../data/project/activity/project-activity.service';
import {Dropdown} from 'primeng/dropdown';

@Component({
  selector: 'app-project-type-edit',
  templateUrl: './project-type-edit.component.html',
  styleUrls: ['./project-type-edit.component.scss'],
  exportAs: 'projectTypeEdit'
})
export class ProjectTypeEditComponent implements OnInit {
  project: Project;

  @Input()
  statusId: number;

  @ViewChild('dropdown', {static: false})
  dropdown: Dropdown;

  status: ProjectStatus;
  tempStatus: ProjectStatus;

  statuses: ProjectStatus[];

  vendors: FinishingVendor[];

  constructor(
    private projectActivityService: ProjectActivityService,
    protected projectHolder: ProjectHolder,
    protected finishingVendorService: FinishingVendorService,
    private projectService: ProjectService
  ) {
    this.project = this.projectHolder.project
  }

  ngOnInit() {
    this.projectService.getProjectTypes().subscribe(statuses => {
      this.statuses = statuses
      this.status = this.statuses.find(status => status.id === this.statusId)
      if(this.status) {
        this.tempStatus = this.status;
      }
    });
  }

  showDropdown() {
    if (this.dropdown) {
      setTimeout(() => {
        const dropdownEl = this.dropdown.el.nativeElement.querySelector('.p-dropdown');
        if (dropdownEl) {
          dropdownEl.click();
        } else {
          console.error('Dropdown element not found');
        }
      }, 1);
    }
  }

  statusChange(status: ProjectStatus) {
    this.status = status
    if((this.status.name === 'InHouseFinishing' || this.status.name === 'OrderFinishing') && typeof this.project.finishingVendor === 'undefined') {
      this.finishingVendorService.getVendors().subscribe(vendors => {
        this.vendors = vendors
        const fVendor = this.vendors.find(vendor => vendor.name === 'PCFI FINISHING')

        this.projectService
        .saveProject({
          id: this.project.id,
          type: this.status,
          finishingVendor: fVendor
        })
        .subscribe(project => {
          this.project.type = project.type
          this.tempStatus = this.status
        }, error => {
          this.status = this.tempStatus
        })
      });
    } else {
      this.projectService
      .saveProject({
        id: this.project.id,
        type: this.status
      })
      .subscribe(project => {
        this.project.type = project.type
        this.tempStatus = this.status
        this.updateActivities()
      }, error => {
        this.status = this.tempStatus
      })
    }
  }

  updateActivities() {
    this.projectActivityService.getProjectActivities(this.project.id).subscribe(projectActivities => {
      this.project.activities = projectActivities
    })
  }


}
